/**
 * The public ENACT site, for links out of the dashboard.
 *
 * One constant rather than a literal in each screen: the address has already
 * moved once (enactlab.org never resolved), and a stale link that silently
 * goes nowhere is worse than no link.
 *
 * Opened at dashboard.enactresearch.com, the dashboard links to enactresearch.com;
 * anywhere else (its run.app address, localhost) to the site's Cloud Run
 * address (the enact-site service). So the move to the lab's own domain
 * (deploy/gcp/domain.sh in the API) needs no change here.
 */
export const SITE_URL = /(^|\.)enactresearch\.com$/.test(window.location.hostname)
  ? 'https://enactresearch.com'
  : 'https://enact-site-2nv7qm6ybq-uc.a.run.app';
